import styled from '@emotion/styled';
import { LinkButton } from '../link-button';

export const DiscordSupportLinkButton = styled(LinkButton)`
  color: #e0cc9d;
  font-size: 14px;
  font-weight: 500;
`;
